"use client";
import dynamic from "next/dynamic";
import { useEffect } from "react";
import { useGetCartQuery } from "@/api/AppApi/services/cart";
import Separator from "@/app/components/lib/Separator";
import CartEmpty from "@/app/components/pages-components/cart/CartEmpty";
import { useDimensions } from "@/hooks/dim-hook";

// The mini-cart item list is hover-revealed (below the fold) and pulls the cart
// item tree — incl. `timezone-utils` → `moment-timezone` (~708KB). Load it only
// when the dropdown actually has items, keeping it out of the site-wide bundle.
const AllCartItems = dynamic(
  () => import("@/app/components/pages-components/cart/all-cart-items/AllCartItems"),
  { ssr: false },
);
import { useTranslation } from "@/hooks/localization/useTranslations";
import { Row } from "@/utils/bootstrap";
import { useAtom } from "jotai";
import HoverDropDown from "../../../header-common/menu/pc/HoverDropDown";
import { cartXAtom } from "./cartAtoms";
import CartMenuBtns from "./CartMenuBtns";
import SvgPcCart from "./SvgPcCart";

// Re-exported for backward compatibility; the canonical source is ./cartAtoms.
export { cartXAtom };

const PcCartMenu = () => {
  const t = useTranslation();
  const [, setCartX] = useAtom(cartXAtom);
  const [ref, dimensions] = useDimensions();
  const getCart = useGetCartQuery();
  const items = getCart.data?.result?.items;
  const itemCount = items?.length ?? 0;
  const tax = getCart.data?.result?.tax;
  useEffect(() => {
    setCartX(dimensions?.x);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensions]);
  // if (getCart.isLoading) return <GeneralApiLoader />;

  return (
    <div ref={ref}>
      <HoverDropDown
        reversed
        down
        title={
          <div className={`pc-cart-btn ${itemCount === 0 ? "empty" : "full"}`}>
            <SvgPcCart />
            {itemCount !== 0 && (
              <span style={{ marginInlineStart: 8 }}>{itemCount}</span>
            )}
            <span className="hide-to-vistor">
              {itemCount === 0 ? t.cart_items : `${t.cart_items} (${itemCount})`}
            </span>
          </div>
        }
      >
        <Row>
          <div style={{ width: "fit-content" }}>
            {itemCount === 0 ? (
              <CartEmpty menu />
            ) : (
              <div className="cart-menu">
                <Separator startLabel={t.cart_items} />
                <Row
                  style={{
                    maxHeight: 320,
                    overflow: "hidden auto",
                    marginBottom: 16,
                  }}
                >
                  <AllCartItems cartItems={items ?? []} menu />
                </Row>
                <CartMenuBtns
                  total={getCart?.data?.result?.total ?? 0}
                  tax={tax}
                />
              </div>
            )}
          </div>
        </Row>
      </HoverDropDown>
    </div>
  );
};

export default PcCartMenu;
